module.exports = __webpack_public_path__ + "static/img/brees-2013-slide-2.f532195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-slide-2.jpg
// module id = +1rw
// module chunks = 1